__turbopack_context__.v({
  "headingContainer": "ImageHotspot-module-scss-module__ozr8bW__headingContainer",
  "image": "ImageHotspot-module-scss-module__ozr8bW__image",
  "imageHotspot": "ImageHotspot-module-scss-module__ozr8bW__imageHotspot",
  "imageOverlay": "ImageHotspot-module-scss-module__ozr8bW__imageOverlay",
  "imageWrapper": "ImageHotspot-module-scss-module__ozr8bW__imageWrapper",
  "mediaContainer": "ImageHotspot-module-scss-module__ozr8bW__mediaContainer",
  "navOverlay": "ImageHotspot-module-scss-module__ozr8bW__navOverlay",
});
